module.exports = __webpack_public_path__ + "static/media/image_7.c4861b04.png";